import { useEffect } from "react";
import { Text, Center, Box, Button, useColorModeValue } from "@chakra-ui/react";
import PuffLoader from "react-spinners/PuffLoader";
import { useFirebaseUser } from "utils/useFirebaseUser";
import { TweetBar } from "./tweet-bar";
import { textStyle } from "theme/names";
import { useDrafts } from "hooks/useDrafts";

interface Props {
  isSelected: boolean;
}

export function DraftsPanel({ isSelected }: Props) {
  const isAuthenticated = useFirebaseUser();
  const tweetbarBg = useColorModeValue("blue.50", "blue.900");
  const threadBg = useColorModeValue("purple.100", "purple.700");
  const { drafts,
    isLoading,
    hasMore,
    isLoadingMore,
    loadDrafts,
    onDelete,
    loadMoreDrafts,
    onAddToQueue } = useDrafts();

  useEffect(() => {
    if (isAuthenticated && isSelected) {
      loadDrafts();
    }
  }, [isAuthenticated, isSelected]);

  if (isLoading) {
    return (
      <Center mt="40">
        <PuffLoader
          color={"#09527c"}
          loading={isLoading}
          cssOverride={{display: "block", margin: "0 auto", borderColor: "red"}}
          size={50}
        />
      </Center>
    );
  }

  if (!isLoading && drafts.length === 0) {
    return (
      <Center mt="44">
        <Box textAlign="center">
          <Text textStyle={textStyle["body.medium.light"]}>No drafts found</Text>
        </Box>
      </Center>
    );
  }

  return (
    <Box>
      <Text textStyle={textStyle["body.medium.light"]} pb={4} mt="7" fontSize="lg" fontWeight="700">
        My Drafts
      </Text>
      {drafts.map((draft) => (
        <TweetBar
          key={draft.id}
          type="drafts"
          tweet={draft}
          bg={tweetbarBg}
          onDelete={onDelete}
          onAddToQueue={onAddToQueue}
        />
      ))}
      {drafts.length > 0 && hasMore && (
        <Box textAlign="center" mt="16">
          <Button
            variant="secondary"
            size="sm"
            onClick={loadMoreDrafts}
            isLoading={isLoadingMore}
          >
            Load more
          </Button>
        </Box>
      )}
    </Box>
  );
}
